module.exports = __webpack_public_path__ + "img/handmade-user.3af57138.svg";